
import TitleBox from '@/components/CSS/TitleBox'
import GoodsListPage from '@/components/GoodsListPage'
import { toMoney } from '@/utils/validate'
export default {
	components: {
		TitleBox,
		GoodsListPage
	},
	data() {
		return {
			pageInfo: {
				page: 1,
				pageSize: 10,
				total: 0
			},
			tableData: [],
			navListItemIndex: '',
			navList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '待结算',
					value: 'TobeSettled'
				},
				{
					label: '结算成功',
					value: 'success'
				},
				{
					label: '结算失败',
					value: 'fail'
				}
			]
		}
	},
	computed: {
		headerCellStyle() {
			return {
				backgroundColor: '#f4f4f4'
			}
		}
	},
	methods: {
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getRecordList()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getRecordList()
		},
		back() {
			this.$router.go(-1)
		},
		navListHandler(item) {
			this.navListItemIndex = item.value
		},
		getRecordList() {
			let p = {
				action: {},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.recordList(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.pageInfo.total = res.data.total
				res.data.records.map(item => {
					item.amount = toMoney(item.amount)
					item.balanceAmount = toMoney(item.balanceAmount)
					return item
				})
				this.tableData = res.data.records
			})
		}
	},
	mounted() {
		this.getRecordList()
	}
}
